// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@5.75.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "\n.form-fields-autocomplete-menu .v-list__tile__title {\n  text-transform: capitalize;\n}\n", "",{"version":3,"sources":["form-fields-autocomplete.css"],"names":[],"mappings":";AACA;EACE,0BAAA;AACF","file":"form-fields-autocomplete.css","sourcesContent":["\n.form-fields-autocomplete-menu .v-list__tile__title {\n  text-transform: capitalize;\n}\n"]}]);
// Exports
module.exports = exports;
